import { jsonldInstagram } from './JsonldStore';

export const updateJsonldInstagram = (value) => jsonldInstagram.update((oldValue) => value);

